import { render, staticRenderFns } from "./_postField.vue?vue&type=template&id=2644f862&scoped=true"
import script from "./_postField.vue?vue&type=script&lang=js"
export * from "./_postField.vue?vue&type=script&lang=js"
import style0 from "./_postField.vue?vue&type=style&index=0&id=2644f862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644f862",
  null
  
)

export default component.exports